import { useState } from 'react';
import { Loader2, Sparkles } from 'lucide-react';
import { aiSummarize } from '@/lib/aiApi';

export default function SummaryTab({ file, documentHash }) {
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function run() {
    setBusy(true);
    setError(null);
    try {
      const data = await aiSummarize(documentHash ? { documentHash } : { file });
      setResult(data);
    } catch (err) {
      setError(err.message || 'Summarize failed.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="p-4 overflow-y-auto h-full">
      {!result && !busy && (
        <button
          type="button"
          onClick={run}
          className="w-full rounded-lg bg-indigo-600 text-white py-2 text-sm font-semibold hover:bg-indigo-700 inline-flex items-center justify-center gap-1"
        >
          <Sparkles className="w-4 h-4" /> Summarize this document
        </button>
      )}
      {busy && (
        <div className="text-center text-sm text-gray-500 py-6 flex items-center justify-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin" /> Generating summary…
        </div>
      )}
      {error && <div className="mt-3 text-sm text-red-600">{error}</div>}
      {result && (
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-semibold">{result.title}</h3>
          </div>
          <p className="text-sm text-gray-700 whitespace-pre-wrap leading-6">{result.summary}</p>
          {result.keyPoints?.length > 0 && (
            <div>
              <h4 className="text-sm font-semibold text-gray-900 mb-2">Key points</h4>
              <ul className="text-sm text-gray-700 space-y-1 list-disc pl-5">
                {result.keyPoints.map((p, i) => <li key={i}>{p}</li>)}
              </ul>
            </div>
          )}
          <button type="button" onClick={run} className="text-xs text-indigo-600 hover:underline">
            Regenerate
          </button>
        </div>
      )}
    </div>
  );
}
